import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { DotLottie } from '@lottiefiles/dotlottie-web';

$(document).ready(function () {
    const sectionObj = $('.ai-preview-information');

    sectionObj.each( function(i) {
        const lottieCanvasBox = $(this).find('.lottie-canvas');
        const lottieCanvas = lottieCanvasBox.find('canvas');

        if (lottieCanvas.length > 0) {
            const lottieSrc = lottieCanvas.data('src');
            const lottieLoop = lottieCanvas.data('loop');

            const dotLottie = new DotLottie({
                autoplay: true,
                loop: lottieLoop,
                canvas: lottieCanvas[0],
                src: lottieSrc
            });
        }
    });
});